import React, { useState } from "react";
import Image from "components/Elements/Image/Image.tsx";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./artistPageModal.scss";

const ArtistPageModal = () => {
  const { getArtist, getTextByKey } = useContent();

  const artist = getArtist() || {
    name: "Test Tester",
    description: "here is good pictures",
    link: "asdasd",
    profileImage: "https://picsum.photos/200",
  };

  return (
    <>
      <div className="artist-info">
        <div className="artist-avatar">
          {<Image src={artist.profileImage} alt="avatar" />}
        </div>
        <div className="artist-description">
          <div className="artist-name">{artist.name}</div>
          <div className="artist-description-text">{artist.description}</div>
        </div>
      </div>
      <div className="artist-page-button">
        <LinkToNewTab
          isNewTab={true}
          page={`stage/${artist.link}`}
          classes="jm-button blank-button"
        >
          {getTextByKey("artist-visit-page")}
        </LinkToNewTab>
      </div>
    </>
  );
};

export default ArtistPageModal;
